import { FunctionComponent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';
import { updateSignInState } from '../../features/sign-in/sign-in-slice';
import { SignInStepType } from '../../features/sign-in/types/SignInStepType';

type ResetPasswordProps = {
  children: any;
};

export const ResetPassword: FunctionComponent<ResetPasswordProps> = (props) => {
  const { signInState } = useAppSelector(
    (state: RootState) => state.signInStore
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(updateSignInState(SignInStepType.ResetPassword));
  }, []);

  return (
    (signInState === SignInStepType.ResetPassword ||
      signInState === SignInStepType.CheckUsernamePassword ||
      signInState === SignInStepType.AcceptTerms ||
      signInState === SignInStepType.SignedIn) &&
    props.children
  );
};
